export default __webpack_public_path__ + "static/media/pricelist-1.04d62129.svg";